<template>
  <div>
    <el-dialog class="QrPayModel" :visible.sync="showVisible" width="600px" title="选择租期">
      <div class="date">
        <el-checkbox-group v-model="selectList">
          <div style="display: grid; grid-template-columns: repeat(5, 1fr);">
            <el-checkbox v-for="(item, index) in  orderBill" :label="item" :disabled="item.disabled" :value="item"
              :key="index">{{ item.current_period }}期</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>

      <template #footer>
        <el-button @click="showVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="aliPay" size="mini">生成支付码</el-button>
      </template>
    </el-dialog>
    <!-- 支付弹框 -->
    <el-dialog class="QrPayModel" :visible.sync="showVisible1" width="800px">
      <iframe :srcdoc="innerHTMLs" frameborder="no" border="0" marginwidth="100px" marginheight="100px" scrolling="no"
        width="750" height="600" style="overflow:hidden;">
      </iframe>
    </el-dialog>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js'
export default {
  name: "QrPayModel",
  props: {

  },
  data() {
    return {
      showVisible1: false,
      orderBill: '',
      showVisible: false,
      selectList: [],
      // 1-12期
      periodOptions: [],
      listData: '',
      innerHTMLs: ''
    }
  },
  methods: {
    init(row) {
      this.showVisible = true;
      this.listData = row
      this.orderBill = row.order_bill;
    },
    async aliPay() {
      this.showVisible = false
      let { order_id } = this.listData
      let data = await OrderApi.aliPayOrderBi({ order_id, order_bill_id: this.selectList })
      console.log(data);
      this.selectList = []
      this.innerHTMLs = data.msg
      this.showVisible1 = true
      this.$nextTick(() => {
        let formId = document.getElementById('alipaysubmit')
        console.log(formId, 'formid')
        // formId.submit()
      })

    }
  },
  created() { },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/qrPayModel.vue